module.exports = "<!-- PostIt: Work Order for Community -->\r\n<div class=\"card card-container photo\" style=\"float:right;position:relative;top:-32px; padding:5px\">\r\n    <img class=\"paper-clip\" src=\"assets/images/paperclip.png\" />\r\n    <a href=\"{{$ctrl.photo}}\" target=\"_blank\">\r\n        <img src=\"{{$ctrl.photo}}\" style=\"width:100%\" />\r\n    </a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/photo-card/photo-card.component.html
// module id = 812
// module chunks = 0